export const isNullOrEmpty = (value) => {
  return value === null || value === undefined || value.toString().trim() === '';
};

export class Validate {
  /**
   * Validates if a field is required and not empty
   */
  static required(value, fieldName) {
    if (isNullOrEmpty(value)) {
      return {
        isValid: false,
        message: `${fieldName} is required`
      };
    }
    return { isValid: true };
  }


  /**
   * Validates that either new account name or selected account is provided
   */
  static accountSelection(newAccountName, selectedAccount) {
    if (!selectedAccount && (!newAccountName || newAccountName.trim() === '')) {
      return {
        isValid: false,
        message: "Either New account name or Select existing account is required"
      };
    }
    return { isValid: true };
  }

  /**
   * Validates phone number when vendor cannot use email only
   */
  static phoneRequired(contactMobile, vendorPassCodeByEmail, fieldName = "Contact mobile") {
    if (!vendorPassCodeByEmail && isNullOrEmpty(contactMobile)) {
      return {
        isValid: false,
        message: `${fieldName} is required when vendor cannot use email only`
      };
    }
    return { isValid: true };
  }

  /**
   * Validates that a value is selected (for dropdowns/selects)
   */
  static selected(value, fieldName) {
    if (!value || (typeof value === 'object' && !value.value)) {
      return {
        isValid: false,
        message: `${fieldName} must be selected`
      };
    }
    return { isValid: true };
  }
}
